// Aspira booking strategy (AlbertaParks, SKParks, PEIParks).
//
// site.reserveUrl already carries contract/park/site ids. We only append
// `&arvdate=MM/dd/yyyy` for the arrival date. Note: uses `&` — the existing
// scanner-written reserveUrl always ends with at least one query parameter.
//
// Kept for historic AvailabilityMatch rows from the pre-August-2025 scanning
// era. Current status for AlbertaParks is documented at /alberta-parks, but
// this strategy must continue to reproduce the legacy URL exactly.

import { format } from "date-fns";

export default {
  buildBookingUrl({ site, arrivalDate }) {
    return `${site.reserveUrl}&arvdate=${format(arrivalDate, "MM/dd/yyyy")}`;
  },

  // Preview URL: rewrite the per-site campsiteDetails.do path to the
  // parent campgroundDetails.do page (which has the campground map).
  // Carries forward parkId + contractCode from the stored reserveUrl.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    const parkId = url.searchParams.get("parkId");
    const contractCode = url.searchParams.get("contractCode");
    const baseUrl =
      url.origin +
      url.pathname.replace("campsiteDetails.do", "campgroundDetails.do");
    return `${baseUrl}?contractCode=${contractCode}&parkId=${parkId}`;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &arvdate=MM/dd/yyyy.",
        },
        departureDate: {
          status: "ignored",
          notes:
            "Aspira URLs only carry arrival; user picks departure on-site.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already encodes contract/park/site.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Not encoded in the Aspira URL.",
        },
      },
    };
  },
};
